import React, { useState} from 'react'
import { Form, Group, FormField, Input , FormButton, FormGroup, FormInput, Label, Header, Button} from 'semantic-ui-react'
import { setMultipleSlotStates } from '../queries'
import { useTranslation } from 'react-i18next'
import { useMutation } from "react-query";
import errorHandler from "../ErrorHandler.jsx"
import { getTimestamp } from '../TimeStamp.jsx';
import { useAppContext } from '../AppContext.jsx';



const MultipleSetSlotForm = ({day, refetchTable}) => {

    const {t} = useTranslation()

    const { rtl } = useAppContext();

    const [from, setFrom] = useState("");
    const [to,setTo] = useState("");

    

    const setMultipleSlotStatesMutation = useMutation(setMultipleSlotStates, {
        onSettled: (response) => {refetchTable();errorHandler(response, t)},
    });

    const handleDisableMultipleSlotStatesMutation = () => {
        setMultipleSlotStatesMutation.mutate({start_time: getTimestamp(from, day), end_time: getTimestamp(to, day), state:false})
    }

    
    const handleEnableMultipleSlotStatesMutation = () => {
        setMultipleSlotStatesMutation.mutate({start_time: getTimestamp(from, day), end_time: getTimestamp(to, day), state:true})
    }


    return(
        <Form>
            <Header as="h3" style={{ minWidth: 'fit-content' }}>{t('act-on-time-range')}</Header>
            <Header as="h5">{`${t('for-day')} ${t(day)}`}</Header>
            <FormGroup>
                <FormField inline style={{ margin: '5px 0'}}>
                    <label style={{ margin: rtl ? '0 0 0 10px' : '0 10px 0 0'}}>{t("from")}</label>
                    <Input name="From" value={from} type="time" onChange ={(_, { value }) => setFrom(value)}/>
                </FormField>
                <FormField inline style={{ margin: '5px 0'}}>
                    <label style={{ margin: rtl ? '0 0 0 10px' : '0 10px 0 0'}}>{t("to")}</label>
                    <Input name="To" value={to} type="time" onChange ={(_, { value }) => setTo(value)}/>
                </FormField>
            </FormGroup>
            <br />
            <FormGroup inline widths={'equal'}>
                <Button color="blue" type='submit' onClick={() => handleEnableMultipleSlotStatesMutation()}>{t("enable-timeslots")}</Button>
                <Button color="red" type='submit' onClick={() => handleDisableMultipleSlotStatesMutation()}>{t("disable-timeslots")}</Button>
            </FormGroup>
            {/* <FormGroup widths='equal'>
            </FormGroup> */}
            {/* <FormGroup>
                <FormField><label></label></FormField>
                <FormField>
                    <Label basic >{t("from")}</Label>
                    <FormInput name="From" value={from} type="time" onChange ={(_, { value }) => setFrom(value)}/>
                </FormField>
                <FormField><label>{t("to")}</label></FormField>
                <FormField>
                    <FormInput name="To" value={to} type="time" onChange ={(_, { value }) => setTo(value)}/>
                </FormField>
                <FormButton type='submit' onClick={() => handleDisableMultipleSlotStatesMutation()}>{t("disable-timeslots")}</FormButton>
                <FormButton type='submit' onClick={() => handleEnableMultipleSlotStatesMutation()}>{t("enable-timeslots")}</FormButton>
            </FormGroup> */}
        </Form>
    )
}

export default MultipleSetSlotForm